import Exports from "../../Pages/Mega/Exports";
import {
  ADD_EVENT_FAIL,
  ADD_EVENT_SUCCESS,
  GET_EVENTS_FAIL,
} from "../calendar/actionTypes";
import {
  ADD_WEBSITE_SUCCESS,
  DELETE_WEBSITE_SUCCESS,
  GET_WEBSITE_FAIL,
  GET_WEBSITE_SUCCESS,
  UPDATE_WEBSITE_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  website: [],

  exports: [],
  error: {},
};

const WEBSITE = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_WEBSITE_SUCCESS:
      return {
        ...state,
        website: action.payload.website,
      };

    case GET_WEBSITE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_WEBSITE_SUCCESS:
      return {
        ...state,
        website: [...state.website, action.payload],
      };

    case ADD_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_WEBSITE_SUCCESS:
      return {
        ...state,
        website: state.website.map((id) =>
          id.id === action.payload.id ? { id, ...action.payload } : id
        ),
        isEventUpdated: true,
      };

    // case UPDATE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //     isEventUpdated: false,
    //   };

    case DELETE_WEBSITE_SUCCESS:
      return {
        ...state,
        website: state.website.filter((id) => id.id !== action.payload),
      };

    // case DELETE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   };

    default:
      return state;
  }
};

export default WEBSITE;
